const zh_hk = {
    msg: {
        hello: "雷猴",
    },
    head: {
        donate: "立即捐款！",
        subscribe: "訂閱！",
    },
    nav: {
        home: "首頁",
        plan: "計劃內容",
        scholarship: "獎學金申請",
        winning_student: "獲獎舊生專區",
        q_a: "常見問題",
        donate: "支持夥伴",
    },
    footer: {
        slogan: "每周運動，保持健康體格！",
    },
    btn_list: {
        want_apply: "我想申請",
        want_dona: "我想捐助",
        learn_more: "了解更多",
        show_more: "顯示更多",
        browse_more: "瀏覽更多",
        his_story: "了解更多",
        want_donor: "我想贊助獎學金",
    },
    // 首頁
    home: {
        banner_tit: "凝動持續運動訓練獎學金",
        banner_apply: "我想申請",
        banner_donate: "我想捐助",
        plan_tit: "計劃目的",
        plan_con: `凝動香港體育基金專注於為基層提供為期最少60小時的體育培訓。鑒於本會希望更合理地利用資源，並凝聚出色舊生，現成立此項獎學金資助表現優異的舊生在完成凝動的培訓後，以自主選擇的方式，持續參與進階專項體育訓練。`,
        more: "了解更多",
        apply_require: "申請資格",
        apply_con: `凡在本會完成最少60小時體育培訓的舊生，<a target='_blank' href='https://form.jotform.com/201342715232443'><font color='#108ee9'>並成為凝動舊生會會員</font></a>，不論年齡、國籍、宗教、種族背景，<b><u>只要</b></u>符合<b><u>經濟及非經濟條件</b></u>，均可申請。`,
        economic: "經濟條件：",
        condition_1: "綜合社會保障援助（綜援）計劃受助家庭學生或；",
        condition_2: "學校書簿津貼計劃受助學生；或",
        condition_3: "在職家庭生活津貼計劃受助家庭；或",
        condition_4: "生活於貧困環境，透過註冊社工或非牟利機構轉介學生",
        show_more: "顯示更多",
        plan_con_tit: "計劃內容",
        plan_con_txt: "獎學金將會為獲獎的舊生提供最高港幣4,800元的學費津貼，為期14個月，用於補貼舊生參加由其他具商業登記證明的體育培訓機構舉辦之進階體育課程的學費。為惠及更多舊生，每位舊生只可以獲發此獎學金一次。舊生獲發此獎學金後，不可再次申請。",
        view_more: "瀏覽更多",
        time_line: [{
            title: "提交申請後一個月內",
            content: "進行遴選及面試，並以電話或電郵方式個別通知得獎者",
        },
        {
            title: "第一階段",
            content: "獲獎舊生參與體育培訓",
        },
        {
            title: "培訓首四個月內",
            content: "獲獎舊生提交此階段所有有關文件，5個工作天內個別通知發放第一階段獎學金安排",
        },
        {
            title: "第二階段",
            content: "獲獎舊生繼續參與體育培訓",
        },
        {
            title: "培訓第五至十個月內",
            content: "獲獎舊生提交此階段所有有關文件，5個工作天內個別通知發放第二階段獎學金安排",
        },
        ],
        timeline: [
          '揀選體育培訓課程及申請獎學金',
          '一個月內進行遴選及面試，以電話或電郵方式個別通知得獎者',
          '報名課程及開始訓練',
          '於指定日期前在線上提交首階段所有有關文件',
          '個別通知發放首階段獎學金安排',
          '獲發首階段獎學金',
          '於指定日期前在線上提交最後階段所有有關文件',
          '個別通知發放最後階段獎學金安排',
          '獲發最後階段獎學金'
        ],
        timeline_title: [
          '申請獎學金',
          '等候報名結果',
          '正式報名課程',
          '提交文件',
          '等候本會審批',
          '獎學金發放',
          '提交文件',
          '等候本會審批',
          '獎學金發放'
        ],
        role_top: '合資格舊生',
        role_bottom: '凝動',
        phase1: '首階段（培訓首4個月）',
        phase2: '最後階段 (培訓最後5-14個月)',
        submit_deadline_text: '獲獎舊生需留意提交所有有關文件的截止日期，本會會於每年以下指定三個月份統一處理發放各階段獎學金事宜，以方便行政安排。',
        submit_deadline0: '提交所有有關文件截止日期',
        submit_deadline1: '3月15日',
        submit_deadline2: '7月15日',
        submit_deadline3: '11月15日',
        release_month0: '發放各階段獎學金月份',
        release_month1: '4月',
        release_month2: '8月',
        release_month3: '12月',
        student_story_tit: "舊生故事",
        student_story: [{
                name: "李伊悅",
                imgPath: require("../../assets/img/home/student_2.png"),
                tit: "《優異！凝動跆拳道》小學（2018-2020）",
                con: `
        我生活於基層家庭，自小有自閉症傾向，所以家人鼓勵我學習跆拳道，希望能夠增強人際溝通技巧。
        我起初練習時因為要與同學碰撞，感到很不開心，下課後一直哭着回家，後來跟教練成為朋友，慢慢開始投入課堂。<br><br>
        我在訓練過程中遇到很多困難，幸好一直有同學及教練的支持。記得考帶的時候要做「踢板」動作，我感到十分害怕，
        但是教練不斷安慰我，同學也替我打氣，最後我成功克服了那次挑戰。另一次深刻的經歷是參加凝動的表演，
        本來我不想參加，因為怕自己會表現得不好，但是教練一直給我信心，最後我們整個隊伍以高難度動作完成表演，
        獲得全場掌聲。<br><br>現在，我已經考獲綠帶，雖然至今仍覺得動作很難學，但我已漸漸享受這項運動了。自從參與凝動的訓練後，
        我的情緒管理有很大進步，也比以前更懂得與人相處。多謝凝動和贊助商的支持，以及教練耐心的教導！`,
                toLink: "https://paper.hket.com/article/2605211/%E8%B7%86%E6%8B%B3%E9%81%93%E6%95%99%E7%B7%B4%E4%BB%A5%E7%AB%A5%E5%BF%83%E6%95%99%E5%AD%B8%20%E8%AE%93SEN%E5%AD%B8%E7%AB%A5%E4%BA%AB%E5%8F%97%E9%81%8B%E5%8B%95",
            },
            {
                name: "林澤豐",
                imgPath: require("../../assets/img/home/student_1.png"),
                tit: "《激發！凝動長跑》中學（2016-2018）",
                con: `很感恩能夠在2018年獲得凝動贊助參與澳洲黃金海岸的10公里比賽。
        雖然我對未能在比賽中達到目標感到遺憾，但這次旅程令我有很大感悟──原來自己一直跟時間競賽，
        無論是飛機延誤引致的15小時旅程，還是在比賽中追趕著時間，抑或是想抓緊在澳洲慢活的一分一秒。
        即使個人有多努力，生命仍然有很多事情不由自己控制。<br><br>最想多謝的是家豪教練。衝線一刻，我覺得自己很沒用，
        意志沉到谷底。我不敢看著家豪教練，也不想告訴他人我的時間。家豪教練走過來跟我說：「蘇炳添也不是次次都跑9.9秒，
        人總有發揮不好的時候。」我知道家豪教練是想鼓勵我，我心底裡非常感動，也告訴自己要抱著搏盡的決心繼續跑下去。<br><br>
        後來回到香港，我終於成功在比賽中刷新個人最佳記錄。但是過了這麼久，我仍難忘那道灑落在海灘的金色餘暉，
        她依然在我心中永遠地照耀和溫暖著我的心頭，黃金海岸之旅是我人生最好的時刻。`,
                toLink: "http://paper.wenweipo.com/2017/12/04/HS1712040018.htm",
            },
            {
                name: "潘凱琳",
                imgPath: require("../../assets/img/home/student_3.png"),
                tit: "《激發！凝動板球》小學（2018-2020）",
                con: `我今年小五，自小四開始被體育科老師邀請參加凝動的板球訓練。之前我從未聽過「板球」，
        在好奇心驅使下，一試後立即愛上這項運動。起初我們的隊伍因經驗不足及技術不及對手， 在一次學校比賽中輸掉了。
        可是，我沒有因而感到挫敗，反而更用心跟從教練的指導，不斷練習、力求進步。
        之後，我被教練邀請參加青苗板球訓練計劃的選拔，結果成功入選了，簡直是莫名的興奮。<br><br>還記得某次參加比賽時，
        過程非常緊湊，我和隊友努力堅持到最後一秒，最終我們獲勝了。 這時，突然有個與我不相熟的隊友跑來跟我擁抱，
        全隊更一起歡呼拍掌呢！<br><br>我感到萬分驚喜和感動，體會到甚麼是團隊精神，讓我知道比賽並不單靠個人實力就能獲勝，
        更重要的是各成員互相配合、共同努力和付出才能成功呢！最後我要感謝凝動及教練悉心的教導。教練除了教導板球技術外，
        他更教導我們調整心理狀態。感謝學校體育科徐老師的推薦，讓我有機會接觸這項運動。另外，我更要感謝我的媽媽，
        每星期早上不辭勞苦地帶我由東涌到銅鑼灣練習，沒有她便沒有今天的我！`,
                toLink: "https://www.sundaykiss.com/432406/%e7%86%b1%e8%a9%b1/%e6%9d%bf%e7%90%83-%e6%bd%9b%e8%83%bd-%e5%85%b1%e8%9e%8d-%e5%8b%87%e6%b0%a3-%e6%85%8b%e5%ba%a6/",
            },
        ],
    },
    // 計劃內容
    plan: {
        banner_tit: [
            "凝動香港體育基金專注於為基層提供為期最少60小時的體育培訓。鑒於本會希望更合理地利用資源，",
            "並凝聚出色舊生，現成立此項獎學金資助表現優異的舊生在完成凝動的培訓後，",
            "以自主選擇的方式，持續參與進階專項體育訓練。",
        ],
        eligibility: {
            con: "凡在本會完成為期最少60小時體育培訓 (所有地區項目、《邨JUMP！》屋邨籃球聯賽及訓練計劃、賽馬會凝動香港SportsCHAT! SHE Inpsires!、領展「愛‧運動，展‧關懷」計劃《領跑》) 的舊生、來年度不再參與凝動60小時體育培訓課程及<a target='_blank' href='https://form.jotform.com/201342715232443'><font color='#108ee9'>成為凝動舊生會會員</font></a>，不論年齡、國籍、宗教、種族背景，只要符合以下<b></u>*經濟及非經濟條件*</u></b>，均可申請。",
            financial_tit: "經濟條件（須提交相關經濟證明或入息證明）：",
            financial: [
                "綜合社會保障援助（綜援）計劃受助家庭學生或；",
                "學校書簿津貼計劃受助學生；或",
                "在職家庭生活津貼計劃受助家庭；或",
                "生活於貧困環境，透過註冊社工或非牟利機構轉介學生",
            ],
            non_financial_tit: "及非經濟條件：",
            non_financial: [
                "在培訓中具備出色的運動表現或潛質；",
                "優秀的課堂出席率；",
                "良好的溝通技巧；",
                "持續追求運動卓越的積極性。",
            ],
            tips: "獎學金只接受完成體育培訓及於來年度不會參與本會進階體育培訓的課程的舊生。",
        },
        content_plan: {
            title: "計劃內容",
            content: `獎學金將會為獲獎的舊生提供最高港幣4,800元的學費津貼，為期14個月，用於補貼舊生參加由其他具商業登記證明的體育培訓機構或球會舉辦之進階體育常規課程^的學費。`,
            tips: "^常規課程指每星期或每月有恆常訓練的課程",
            content_item: [
                "獎學金優先補貼舊生參與接受本會培訓時相同或相關之專項體育培訓課程。",
                "獎學金僅限於補貼舊生參與課程或培訓班之學費或教練費，並不包括購買裝備費用或其他用途。",
                "每位舊生終生只可以獲發此獎學金一次。舊生獲發此獎學金後，不可再次申請。",
                "獲獎舊生可以報讀學費金額超過4,800元之課程，唯獲獎學金最高僅可津貼港幣4,800元。",
            ],
        },
        details_plan: {
            title: "計劃細節",
            content_item: [
                "獎學金全年接受申請。",
                "獲發獎學金的金額<b><u>上限</b></u>是<b><u>港幣4,800元</b></u>。獲獎舊生可以報讀學費金額超過4,800元之課程，唯獲獎學金最高僅可津貼港幣4,800元。獎學金每年將<b><u>分兩期發放</b></u>，首階段獎學金計算方法為最多<b><u>申領港幣1,600元</b></u>，而最後階段最多可申領<b><u>港幣3,200元</b></u>。獎學金會以較低的金額計算。在任何情況下，申領總額皆不可超越港幣4,800元。",
                " 首階段（參與體育培訓首四個月內）：公佈結果後，獲獎舊生需在截止日期前將以下所有文件上載至本會網站：",
                "1. 此階段所有學費收據（清晰顯示課程名稱、上堂日期及時間）",
                "2. 課堂出席證明（須清楚例明出席的日期及教練簽名）",
                "3. 3-4張課堂照片（至少有一張課堂相片能清晰拍下舊生的臉孔）如所提供資料齊全，本會將會安排獲獎舊生親臨本會辦事處領取獎學金。",
                "最後階段（參與體育培訓第五至十四個月）：獲獎舊生須在截止日期前將以下所有文件上載至本會網站：",
                "1. 最後階段學費所有收據（清晰顯示課程名稱、上堂日期及時間）",
                "2. 學習報告（分享訓練時的經歷及參與課程帶來的改變）",
                "3. 成功修畢課程的證明文件",
                "4. 3-4張課堂照片（至少有一張課堂相片能清晰拍下舊生的臉孔）如所提供資料齊全，本會將會安排獲獎舊生親臨本會辦事處領取獎學金。",
                "申請人將於提交申請後一個月內以電話或電郵方式個別通知申請結果。如申請人於面試後兩星期後仍未收到任何形式通知，可視作落選論。若本會不能聯絡該舊生、無法提供相關證明文件或在截止日期前提供所有文件，本會有權拒絕相關申請。",
                "獎學金會以現金支票及實報實銷形式發放。",
            ],
        },
        responsibilities_plan: {
            title: "申請人的責任",
            content_item: [
                "保留所有課程費用收據作實報實銷用途。",
                "按時上載所有所需文件。",
                "出席兩次本會的聯誼活動。",
                "代表本會向現屆學生分享及表演。",
            ],
        },
    },
    // 奖学金申请
    scholarship: {
        time_tit: "申請流程",
        test_span: [
            "合資格的凝動舊生須通過網上系統提交申請獎學金。",
            "申請時所需文件包括1）經濟證明文件 2）欲申請課程的資料 3）本會課程畢業證書（如有）須在同一限期之前通過網上申請系統提交。",
            "如有其他有助申請的資料（如：由教練撰寫的推薦信或申請人的比賽影片）請於填妥上述申請表時一併提交。",
            `申請人在填寫及提交奬學金計劃的申請前，須細閱載於本網站有關奬學金計劃的<a href="#/overview"><font color="#108ee9">內容</font></a>及<a href="#/faq"><font color="#108ee9">申請人常見問題</font></a>。`,
        ],
        plan_tit: "計劃概括",
        time_line: [{
                title: "提交申請後一個月內",
                content: "進行遴選及面試，並以電話或電郵方式個別通知得獎者",
            },
            {
                title: "第一階段",
                content: "獲獎舊生參與體育培訓",
            },
            {
                title: "培訓首四個月內",
                content: "獲獎舊生提交此階段所有有關文件，5個工作天內個別通知發放第一階段獎學金安排",
            },
            {
                title: "第二階段",
                content: "獲獎舊生繼續參與體育培訓",
            },
            {
                title: "培訓第五至十個月內",
                content: "獲獎舊生提交此階段所有有關文件，5個工作天內個別通知發放第二階段獎學金安排",
            },
        ],
        timeLines_Detail: [{
                expand: false,
                phase: "第一期",
                info: [{
                        year: "2020",
                        info: [{
                                month: "11月",
                                content: "20/11 截止申請",
                            },
                            {
                                month: "11月",
                                content: "26/11 完成遴選及面試",
                            },
                            {
                                month: "11月",
                                content: "27/11 或之前以電話或電郵方式個別通知得獎者",
                            },
                            {
                                month: "12月",
                                content: "獲獎舊生參與體育培訓（第一階段）",
                            }
                            // {
                            //   month: "12月",
                            //   content:
                            //     "31/12 或之前獲獎舊生提交所需要文件（第一階段學費所有收據及課程出席證明*），5個工作天內個別通知發放第一階段獎學金安排",
                            //   tips: "*課堂出席證明須清楚例明出席的日期及教練簽名",
                            // },
                        ],
                    },
                    {
                        year: "2021",
                        info: [{
                                month: "3月",
                                content: "31/3 或之前獲獎舊生提交所需要文件（第一階段學費所有收據及課程出席證明*），5個工作天內個別通知發放第一階段獎學金安排",
                                tips: "*課堂出席證明須清楚例明出席的日期及教練簽名",
                            },
                            {
                                month: "4-9 月",
                                content: "獲獎舊生繼續參與體育培訓（第二階段）"
                            },
                            {
                                month: "9月",
                                content: "31/9 或之前獲獎舊生提交學習報吿及所需要文件（第二階段學費所有收據、課程出席證明*)",
                                tips: "*課堂出席證明須清楚例明出席的日期及教練簽名",
                            },
                            {
                                month: "10月",
                                content: "獲獎舊生出席頒獎典禮，當日發放第二階段獎學金"
                            },
                        ],
                    },
                ],
            },
            {
                expand: false,
                phase: "第二期",
                info: [{
                        year: "2021",
                        info: [{
                                month: "4月",
                                content: "30/4 截止申請",
                            },
                            {
                                month: "5月",
                                content: "31/5 完成遴選及面試",
                            },
                            {
                                month: "6月",
                                content: "5/6 或之前以電話或電郵方式個別通知得獎者",
                            },
                            {
                                month: "6月-9月",
                                content: "獲獎舊生參與體育培訓（第一階段）",
                            },
                            {
                                month: "9月",
                                content: "30/9 或之前獲獎舊生提交所需要文件（第一階段學費所有課程收據及課程出席證明*），5個工作天內個別通知發放第一階段獎學金安排",
                                tips: "*課堂出席證明須清楚例明出席的日期及教練簽名",
                            },
                            {
                                month: "10月-12月",
                                content: "獲獎舊生繼續參與體育培訓（第二階段）",
                            },
                        ],
                    },
                    {
                        year: "2022",
                        info: [{
                                month: "1-3月",
                                content: "獲獎舊生繼續參與體育培訓（第二階段）",
                            },
                            {
                                month: "3月",
                                content: "31/3 或之前獲獎舊生提交學習報吿及所需要文件（第二階段學費所有收據及課程出席證明*)",
                                tips: "*課堂出席證明須清楚例明出席的日期及教練簽名",
                            },
                            {
                                month: "4月",
                                content: "獲獎舊生出席頒獎典禮，當日發放第二階段獎學金",
                            },
                        ],
                    },
                ],
            },
        ],
        other_tips: [
            "合資格的凝動舊生須通過網上系統提交申請獎學金。<br><br>",
            "申請時所需文件包括1）經濟證明文件 2）欲申請課程的資料 3）本會課程畢業證書（如有）須在同一限期之前通過網上申請系統提交。<br><br>",
            "如有其他有助申請的資料（如：由教練撰寫的推薦信或申請人的比賽影片）請於填妥上述申請表時一併提交。<br><br>",
            `申請人在填寫及提交奬學金計劃的申請前，須細閱載於本網站有關奬學金計劃的<a href="#/overview"><font color="#108ee9">內容</font></a>及<a href="#/faq"><font color="#108ee9">申請人常見問題</font></a>。<br><br>`,
        ],
        other_btn: "立即報名",
    },
    // 歷屆得獎者
    awardees: {
        title: "歷屆得獎者",
        tips: "得獎結果有待公佈。",
        period: ["第一期", "第二期"],
        peopleInfo: [{
                name: "林澤豐",
                source: "(2016- -2018)《激發 !凝動長跑》-官塘",
                photo: require("../../assets/img/winning/dummy1.png"),
                story: "http://paper.wenweipo.com/2017/12/04/HS1712040018.htm",
            },
            {
                name: "潘凱琳",
                source: "(2016- -2018)《激發 !凝動長跑》-沙田",
                photo: require("../../assets/img/winning/dummy2.png"),
                story: "https://www.sundaykiss.com/432406/%e7%86%b1%e8%a9%b1/%e6%9d%bf%e7%90%83-%e6%bd%9b%e8%83%bd-%e5%85%b1%e8%9e%8d-%e5%8b%87%e6%b0%a3-%e6%85%8b%e5%ba%a6/",
            },
            {
                name: "李伊悅",
                source: "(2016- -2018)《激發 !凝動長跑》-黃大仙",
                photo: require("../../assets/img/winning/dummy3.png"),
                story: "https://paper.hket.com/article/2605211/%E8%B7%86%E6%8B%B3%E9%81%93%E6%95%99%E7%B7%B4%E4%BB%A5%E7%AB%A5%E5%BF%83%E6%95%99%E5%AD%B8%20%E8%AE%93SEN%E5%AD%B8%E7%AB%A5%E4%BA%AB%E5%8F%97%E9%81%8B%E5%8B%95",
            },
            {
                name: "潘凱琳",
                source: "(2016- -2018)《激發 !凝動長跑》-長洲",
                photo: require("../../assets/img/winning/dummy4.png"),
                story: "https://www.sundaykiss.com/432406/%e7%86%b1%e8%a9%b1/%e6%9d%bf%e7%90%83-%e6%bd%9b%e8%83%bd-%e5%85%b1%e8%9e%8d-%e5%8b%87%e6%b0%a3-%e6%85%8b%e5%ba%a6/",
            },
        ],
        submin_tit: "遞交報告",
        submin_per: "第一期",
        submit: [{
                tit: "首階段（參與體育培訓首四個月內）",
                con: "得獎者需在截止日期前遞交此階段內所有收據證明及課程出席證明。逾期遞交的報告將不獲處理。",
                con_tit:"請準備好以下文件：",
                con_txt1:"此階段所有學費收據",
                con_txt2:"課堂出席證明（須清楚例明出席的日期及教練簽名）",
                con_txt3:"3-4張課堂照片（至少有一張課堂相片能清晰拍下舊生的臉孔）",
                btn: "遞交",
                toLink: "https://form.jotform.me/201272049184451",
            },
            {
                tit: "最後階段（參與體育培訓第五至十四個月）",
                con: "得獎者須於在截止日期前遞交學習報告，並附上此階段內所有收據證明及課程出席證明。逾期遞交的報告將不獲處理。",
                con_tit:"請準備好以下文件：",
                con_txt1:"最後階段學費所有收據",
                con_txt2:"學習報告",
                con_txt21:"分享一個訓練時的深刻經歷，並説明這經歷為你帶來甚麼啟發？（不少於100字）",
                con_txt22:"參與這訓練課程令你在運動表現及個人成長帶來甚麼改變？（不少於100字）",
                con_txt3:"成功修畢課程的證明文件",
                con_txt4:"3-4張課堂照片（至少有一張課堂相片能清晰拍下舊生的臉孔）",
                btn: "遞交",
                toLink: "https://form.jotform.me/201272348215448",
            },
        ],
    },
    // 常見問題
    q_a: {
      question8_content: '獎學金會分兩個階段發放：<br>\
      首階段（參與體育培訓首四個月內）：公佈結果後，獲獎舊生需在截止日期前將以下所有文件上載至本會網站：<br>\
      1. 此階段所有學費收據<br>\
      2. 課堂出席證明（須清楚例明出席的日期及教練簽名）<br>\
      3. 3-4張課堂照片（至少有一張課堂相片能清晰拍下舊生的臉孔）<br>\
      如所提供資料齊全，本會將會安排獲獎舊生親臨本會辦事處領取獎學金。<br><br>\
      最後階段（參與體育培訓第五至十四個月）：獲獎舊生須在截止日期前將以下所有文件上載至本會網站：<br>\
      1. 最後階段學費所有收據<br>\
      2. 學習報告（分享訓練時的經歷及參與課程帶來的改變）<br>\
      3. 成功修畢課程的證明文件<br>\
      4. 3-4張課堂照片（至少有一張課堂相片能清晰拍下舊生的臉孔）<br>\
      如所提供資料齊全，本會將會安排獲獎舊生親臨本會辦事處領取獎學金。<br><br>',
      
        contant_title: "獎學金 Q&A",
        questions: [{
                tips: "何處可得知獎學金最新資訊？",
                answer: "有關獎學金的最新資訊將於本會網站公佈。",
                expandStatus: true,
            },
            {
                tips: "申請獎學金要具備甚麼資格？",
                answer: "凡在本會完成為期最少60小時體育培訓 (所有地區項目、《邨JUMP！》屋邨籃球聯賽及訓練計劃、賽馬會凝動香港SportsCHAT! SHE Inpsires!、領展「愛‧運動，展‧關懷」計劃《領跑》) 的舊生、來年度不再參與凝動60小時體育培訓課程及<a href='https://form.jotform.me/201342715232443' target='_blank'><font color='#108ee9'>成為凝動舊生會會員</font></a>，不論年齡、國籍、宗教、種族背景，<b><u>只要</b></u>符合以下<b><u>*經濟及非經濟條件*</b></u>，均可申請。",
                contentItem2: {
                    title: "經濟條件（須提交相關經濟證明或入息證明）：",
                    lis: [
                        "綜合社會保障援助（綜援）計劃受助家庭學生或；",
                        "學校書簿津貼計劃受助學生或；",
                        "在職家庭生活津貼計劃受助家庭或；",
                        "生活於貧困環境，透過註冊社工或非牟利機構轉介學生",
                    ],
                },
                contentItem3: {
                    title: "及非經濟條件：",
                    content: "申請者須在培訓中具備出色的運動表現或潛質、優秀的課堂出席率、良好的溝通技巧及持續追求運動卓越的積極性。",
                },
                contentItem4: "獎學金只接受完成體育培訓及將不會參與本會進階體育培訓的課程的舊生。",
                expandStatus: true,
            },
            {
                tips: "獎學金會在什麼時候申請開放？",
                answer: "獎學金全年接受申請，名額有限，先到先處理。",
                expandStatus: true,
            },
            {
                tips: "獎學金可應用於哪些課程？",
                answer: "獎學金可應用於舊生參加其他具商業登記證明的體育培訓機構或球會舉辦之進階體育課程，優先補貼舊生參與接受本會培訓時相同或相關之常規專項體育培訓課程。",
                contentItem4: "<br>獎學金可應用的課程需連續十二或十四個月期間上課。",
                expandStatus: true,
            },
            {
                tips: "舊生可以如何申請獎學金？",
                answer: "符合資格的舊生可到凝動網站填妥網上申請表。",
                expandStatus: true,
            },
            {
                tips: "舊生須準備甚麼文件申請獎學金？",
                answer: "申請人須在表格上載： 1）本會課程畢業證書 2）有意報讀課程的資料 3）經濟證明文件。獲獎舊生亦需要保留課程的收據以作申請之用。",
                expandStatus: true,
            },
            {
                tips: "何時知道獎學金的申請結果？",
                answer: "申請人將於提交申請後一個月內以電話或電郵方式個別通知申請結果。",
                expandStatus: true,
            },
            {
                tips: "本會會如何發放獎學金？",
                answer: '獲獎舊生需留意提交所有有關文件的截止日期，本會會於每年以下指定三個月份統一處理發放各階段獎學金事宜，以方便行政安排。',
                contentItem4: "若本會不能聯絡該舊生、無法提供相關證明文件或在截止日期前提供所有文件，本會有權拒絕相關申請。",
                expandStatus: true,
            },
            {
                tips: "如果舊生完全無法負擔第一階段的學費，可以怎麼辦？",
                answer: "舊生如有任何特殊情況，請在面試時提出，本會會按個別情況酌情考慮處理。",
                expandStatus: true,
            },
            {
                tips: "獲發獎學金的金額上限是多少？",
                answer: `獲發獎學金的金額上限是港幣4,800元。獲獎舊生可以報讀學費金額超過4,800元之課程，唯獲獎學金最高僅可津貼港幣4,800元。
        獎學金每年將分兩期發放，首階段獎學金計算方法為最多申領港幣1,600元，而最後階段最多可申領港幣3,200元。獎學金會以較低的金額計算。在任何情況下，申領總額皆不可超越港幣4,800元。
        `,
                expandStatus: true,
            },
            {
                tips: "獎學金會以甚麼形式發放？",
                answer: "獎學金會以現金支票及實報實銷形式發放。",
                expandStatus: true,
            },
            {
                tips: "申請獎學金有甚麼遴選過程？",
                answer: "申請人需填妥網上申請表，入圍者將獲電話或電郵通知出席面試（形式待定）。本會將會成立一個評選委員會，以本會代表、舊生代表、教練及捐款人代表等組成。評選委員會將有最終決定權。遴選結束後，本會將以電話或電郵方式通知申請人申請結果。如申請人於面試後兩星期後仍未收到電話、電郵或任何其他形式通知，可視作落選論。",
                expandStatus: true,
            },
            {
                tips: "申請獎學金的次數有上限嗎？",
                answer: "為了惠及更多舊生，每位舊生終生只可以獲發此獎學金一次。舊生獲發此獎學金後，不可再次申請。",
                expandStatus: true,
            },
            {
                tips: "獲獎舊生有甚麼責任？",
                contentItem2: {
                    title: "獲獎舊生須：",
                    lis: [
                        "保留所有課程費用收據作實報實銷用途。",
                        "按時上載所有所需文件。",
                        "出席兩次本會的聯誼活動。",
                        "代表本會向現屆學生分享及表演。",
                    ],
                },
                expandStatus: true,
            },
        ],
        other_questions: "如有其他問題，請致電56056013聯絡丘小姐。",
        hot_line: "熱線 +852 560 560 13",
    },
    // 合作夥伴
    supportpartners: {
        banner_title: "支持夥伴",
        tit1: "贊助芳名錄",
        con1: "承蒙各界善長／公司／機構鼎力贊助支持，謹此向各位致以衷心的感謝。",
        donors_tit: "創始贊助",
        donors_data: ["秀清慈善基金有限公司"],
        support_order: [{
                tit: "如何捐款？",
                con: "為了推展本獎學金計劃，您的贊助對本會的受惠舊生意義重大。我們希望社會各界繼續支持本獎學金，讓有需要的舊生可以持續投入體育培訓，發展所長，實現理想。金額隨意，多少不拘。每位受助舊生一年最高可獲港幣4,800元獎學金，故港幣4,800元或以上的捐款可以個人、公司或團體名義命名獎學金。有意贊助獎學金者請透過銀行入賬、劃線支票、PayMe或PayPal的方式捐款，再填妥指定表格。",
            },
            {
                tit: "退款政策",
                con: "網上捐款一經確認後便不能取消及退款，敬請於過賬前確認捐款金額。",
            },
        ],
        dona_methods: [{
                tit: "<u>透過PayPal捐款</u>",
                con: "請前往<a href='https://donation.inspiringhk.org/campaigns/view/3' target='blank'><font color='#108ee9'>捐款網頁</font></a>，選擇「線上捐款」填寫網上表格，即時捐款。",
            },
            {
                tit: "<u>透過銀行入賬、劃線支票或PayMe捐款</u>",
                con: "請根據<a href='https://donation.inspiringhk.org/' target='_blank' style='color:#108ee9;'>網頁上的指示</a>捐款，保留存款收條或轉賬紀錄，然後填寫<a href='https://form.jotform.com/201622278649056' target='_blank' style='color:#108ee9;'>網上表格</a>，並上載捐款紀錄。",
            },
        ],
        btn_content: "我想贊助獎學金",
    },
    // 立即申请
    scholarshipapplytips: {
        title: "立即申請",
        other_tips: [
            "合資格的凝動舊生可申請本奬學金計劃。申請須在2020年11月20日或之前通過網上申請系統提交。",
            "申請時所需文件包括1）本會課程畢業證書 2）申請課程的資料 3）經濟證明文件須在同一限期之前通過網上申請系統提交。",
            "如有其他有助申請的資料（如：由教練撰寫的推薦信或申請人的比賽影片）請於填妥上述申請表時一併提交。",
            `申請人在填寫及提交奬學金計劃的申請前，須細閱載於本網站有關奬學金計劃的<a href="#/overview"><font color="#108ee9">內容</font></a>及<a href="#/faq"><font color="#108ee9">申請人常見問題</font></a>。`,
        ],
        sxTip: "臨近申請截止日期,接受網上申請的伺服器可能因為處理大量申請而超出負荷。申請人應盡早遞交申請,以確保在限期前完成網上申請程序。",
        },
        externalsportsprogrammes:{
            tit:'坊間體育課程參考名單',
            conlist:[
              '1. 以下名單僅供合資格的凝動舊生申請「凝動持續運動訓練獎學金」時作參考之用，並不代表本會推薦名單上的課程。',
              '2. 請留意獎學金所涵蓋的課程不限名單上的課程，舊生可以參加坊間其他具商業登記證明的體育培訓機構或球會舉辦之體育常規課程。',
              '3. 任何有關課程的內容、更新及改動，舊生及家長應向教練或有關團體查詢及了解最新情況，以課程主辦單位公佈的資訊為準，名單僅作參考。',
              '4. 有關獎學金詳情，請瀏覽<font color="#2191d0"><a href="http://trainingfund.inspiringhk.org/#/overview" target="_blank">本會網頁</a></font>。',
            ],
            btn:'按此查看參考名單'
          }
};

export default zh_hk;